import { PATHS } from '@ctcells/core'
import { t } from '@ctcells/i18n'
import { Navigate, useNavigate, useParams } from 'react-router'

import { cx } from '../atoms/cx.ts'
import { RecipeTemplateDetailContainer } from '../screens/templates/RecipeTemplatesContainer.tsx'
import {
  RECIPE_TEMPLATE_TAB,
  STANDARD_RECIPE_TEMPLATE_ID,
} from '../screens/templates/templateModel.ts'
import { TemplatesContainer } from '../screens/templates/TemplatesContainer.tsx'

/**
 * 작업 준비 › 템플릿 라우트 — 🔴 «레시피» 템플릿 하나뿐이다(eric 2026-10-26 「응.. 다 빼줘」).
 *
 *   /recipes/templates                         목록
 *   /recipes/templates/recipe                  목록(옛 「레시피」 칩 주소)
 *   /recipes/templates/recipe/standard         목록 + 레시피 템플릿 오른쪽 판
 *   그 밖(/labware · /reagent · /work · /deck · …/new · 모르는 id)  → 목록으로(`replace`)
 *
 * 🔴 데크 · 작업 · 랩웨어 · 시약 템플릿 화면과 추가 창은 걷었다 — 옛 주소 · 즐겨찾기가 빈 화면이 되지 않게 목록으로 보낸다.
 * 🔴 작업 준비 탭 줄은 「템플릿」이 고른 채다(`resourceTab="templates"`).
 */
export function TemplatesSplitRoute() {
  const navigate = useNavigate()
  const { kind, itemId } = useParams()
  if (
    (kind !== undefined && kind !== RECIPE_TEMPLATE_TAB) ||
    (itemId !== undefined && itemId !== STANDARD_RECIPE_TEMPLATE_ID)
  )
    return <Navigate replace to={PATHS.templates} />
  const selectedId = itemId
  const back = () => void navigate(PATHS.templates)
  return (
    <div className={cx('splitpage', selectedId !== undefined && 'splitpage--open')}>
      <TemplatesContainer resourceTab="templates" selectedId={selectedId} />
      {selectedId === undefined ? null : (
        <aside aria-label={t('tab.template.recipe')} className="splitpage__pane" key={selectedId}>
          <RecipeTemplateDetailContainer onClose={back} />
        </aside>
      )}
    </div>
  )
}
